module.exports = __webpack_public_path__ + "static/science-image-V6-bde9995975a95a4f4e4ed9f7447f6935.jpg";